export default {
      id: "edit-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#edit",
      toString: function () {
        return this.url;
      }
    }